import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ReportFilterCondition } from 'dashboard/lib/reports/filterMetas';
import { Environment } from 'dashboard/models/environment';
import { Report, ReportMatchResult, ReportStatus } from 'dashboard/models/report';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export type ReportsActions =
  | Action<ReportsActionType.SetReports, SetReportsPayload>
  | Action<ReportsActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<ReportsActionType.SetPageSize, SetPageSizePayload>
  | Action<ReportsActionType.SetFilters, SetFiltersPayload>
  | Action<ReportsActionType.SetSortParams, SetSortParamsPayload>;

export enum ReportsActionType {
  SetReports = 'reports/SET_REPORTS',
  SetCurrentPage = 'reports/SET_CURRENT_PAGE',
  SetPageSize = 'reports/SET_PAGE_SIZE',
  SetFilters = 'reports/SET_FILTERS',
  SetSortParams = 'reports/SET_SORT_PARAMS',
}

export interface ReportsFilterParams {
  omni?: string;
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  status?: ReportStatus[];
  matchResult?: ReportMatchResult[];
  reportTemplateIds?: string[];
  tagIds?: string[];
  conditions?: ReportFilterCondition[][];
}

interface SetReportsPayload {
  reports: Report[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export function setReports(
  reports: Report[],
  environment: Environment,
  paginationParams: PaginationParams,
): Action<ReportsActionType.SetReports, SetReportsPayload> {
  return {
    payload: {
      reports,
      environment,
      paginationParams,
    },
    type: ReportsActionType.SetReports,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<ReportsActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: ReportsActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<ReportsActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: ReportsActionType.SetPageSize,
  };
}

interface SetFiltersPayload {
  filters: ReportsFilterParams;
}

export function setFilters(
  filters: ReportsFilterParams,
): Action<ReportsActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: ReportsActionType.SetFilters,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<ReportsActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: ReportsActionType.SetSortParams,
  };
}
